<template>
  <div
    class="wrn-c-12 wrn-p-x-1 wrn-p-y-05 top wrn-flex modal-footer__background"
    data-e2e="modalButtons"
  >
    <SimpleButton
      data-cy="left-button"
      class="flex-1"
      :label="leftButtonLabel"
      :disabled="disabledLeftButton"
      @click="emitLeftButtonClickedEvent"
    />
    <SimpleButton
      v-if="!hideRightButton"
      data-cy="right-button"
      class="flex-1"
      :label="rightButtonLabel"
      :disabled="disabledRightButton"
      @click="emitRightButtonClickedEvent"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { SimpleButton } from '@/modules/common/components/__deprecated__/SimpleButton';

@Component({
  components: { SimpleButton }
})
export default class ModalFooter extends Vue {
  @Prop({ type: String, required: true })
  public leftButtonLabel!: string;

  @Prop({ type: String, default: 'FECHAR' })
  public rightButtonLabel!: string;

  @Prop({ type: Boolean, default: false })
  public hideRightButton!: boolean;

  @Prop({ type: Boolean, default: false })
  public disabledRightButton!: boolean;

  @Prop({ type: Boolean, default: false })
  public disabledLeftButton!: boolean;

  private emitLeftButtonClickedEvent() {
    /**
     * Left button clicked event.
     * @type {void}
     */
    this.$emit('left-button-clicked');
  }

  private emitRightButtonClickedEvent() {
    /**
     * Right button clicked event.
     * @type {void}
     */
    this.$emit('right-button-clicked');
  }
}
</script>

<style lang="less">
.flex-1 {
  flex: 1;
}
.modal-footer__background {
  background: @background-primary;
}
</style>
